import { useEffect, useState } from 'react';
import { db } from '../firebase'; // adjust path as needed
import { collection, query, where, getDocs } from 'firebase/firestore';

// Generates a persistent anonymous ID for the visitor
const getVisitorId = () => {
    let id = localStorage.getItem('visitorId');
    if (!id) {
        id = crypto.randomUUID(); // Or use a nanoid fallback
        localStorage.setItem('visitorId', id);
    }
    return id;
};

export const useVisitorCardLimit = (maxCards = 500) => {
    const [visitorId] = useState(getVisitorId);
    const [limitReached, setLimitReached] = useState(false);
    const [loading, setLoading] = useState(true);

    const checkLimit = async () => {
        const q = query(collection(db, 'cards'), where('visitorId', '==', visitorId));
        const snapshot = await getDocs(q);
        setLimitReached(snapshot.size >= maxCards);
        setLoading(false);
    };

    useEffect(() => {
        checkLimit();
    }, []);

    return { visitorId, limitReached, loading, checkLimit };
};
